import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper"; // import { getCurrentCountries } from "@insite/client-framework/Services/WebsiteService";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { getLanguages, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import { CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { formatPhoneNumber } from "@tKgpco/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tKgpco/Common/Utilities/validate";
// import {
//     existingCustomerValidatorConfig,
//     FormErrorsStateType,
//     intialErrorFormState,
//     ValidatorConfigType,
// } from "@tKgpco/Components/CreateAccountExistingFormValidatorConfig";
import addAccount from "@tKgpco/Overrides/Store/Data/Accounts/Handlers/AddAccount";
import { signInExistingAccountStyles } from "@tKgpco/Overrides/Widgets/SignIn/SignInExistingAccount";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { ReactNode, RefObject, useContext, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import { ValidatorRuleType } from "@tKgpco/Common/Utilities/validate";
import sendDiscrepancyDisputeHandler from "@tKgpco/Store/Data/CustomerServiceForms/Handlers/SendDiscrepancyDispute";
import sendCreditAnalystHandler from "@tKgpco/Store/Data/CustomerServiceForms/Handlers/SendCreditAnalyst";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    title: "",
    compAddLine1: "",
    city: "",
    state: "",
    zipCode: "",
    email: "",
    phone: "",
    userMessage: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const existingCustomerValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        regex: /^[aA-zZ]+$/,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        regex: /^[aA-zZ]+$/,
        label: "Last Name",
    },
    title: {
        required: true,
        minLength: 2,
        label: "Title",
    },

    compAddLine1: {
        required: true,
        label: "Address Line 1",
    },
    city: {
        required: true,
        minLength: 2,
        label: "City",
    },
    state: {
        required: true,
        label: "State",
    },
    email: {
        required: true,
        regex: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        label: "Email Address",
    },
    zipCode: {
        required: true,
        minLength: 5,
        label: "Zip Code",
    },
    phone: {
        required: true,
        label: "Phone Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Phone Number",
    },
    extension: {
        required: false,
        label: "Extension",
    },
    fax: {
        required: false,
        label: "Fax Number",
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Fax Number",
    },
    userMessage: {
        required: true,
        minLength: 10,
        label: "Message",
    },
};

const mapDispatchToProps = {
    addAccount,
    signIn,
    validatePassword,
    loadCurrentCountries,
    loadBillTo,
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: RefObject<ReCAPTCHA | null> },
        boolean
    >(validateReCaptcha),
    sendCreditAnalystHandler,
};

const mapStateToProps = (state: ApplicationState) => ({
    countries: getCurrentCountries(state),
    shouldLoadCountries: !getCurrentCountries(state),
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state),
    languages: getLanguages(state),
    defaultCountryAbbreviation: state.context.website.properties.defaultCountryAbbreviation,
    billToState: getBillToState(state, state.context.session.billToId),
    billToId: state.context.session.billToId,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CreditAnalystFormStyles {
    cancelButton?: LinkPresentationProps;
    form?: InjectableCss;
    selectStateStyle?: SelectPresentationProps;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    extGridItem?: GridItemProps;
    phoneExtGridItem?: GridItemProps;
    phoneExtRow?: InjectableCss;
    bufferGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    passwordIcon?: IconPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    reasonGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    requiredLabelGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    passwordRequirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordGridContainer?: GridContainerProps;
    container?: InjectableCss;
    title?: InjectableCss;
    headingInstruction?: InjectableCss;
    userInfoTitle?: InjectableCss;
}

export const CreditAnalystFormStyles: CreditAnalystFormStyles = {
    container: {
        css: css`
            background: #f1f6fb;
            border: 1px solid #e1e7ed;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        `,
    },
    title: {
        css: css`
            padding: 20px 50px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 20px;
                        `,
                    ],
                    "max",
                )}
            border-bottom: 2px solid #1e75ba;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.smallest};
        `,
    },
    userInfoTitle: {
        css: css`
            text-transform: uppercase;
            font-size: 22px;
            color: ${COLORS.primary.light};
            border-bottom: 1px solid ${COLORS.primary.light};
            padding-bottom: 5px;
        `,
    },
    mainGridContainer: {
        css: css`
            padding-top: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            input,
                            select {
                                font-size: ${TYPOGRAPHY.size.base} !important;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    form: {
        css: css`
            padding: 50px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 20px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    headingInstruction: {
        css: css`
            padding: 20px 50px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 20px;
                        `,
                    ],
                    "max",
                )}
            p {
                font-size: ${TYPOGRAPHY.size.smallest};
            }
        `,
    },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    // emailTextField: {
    //     css: css`

    //     `,
    // },
    userGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            // padding-left: 100px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    userGridContainer: {
        css: css`
            .address-line-one {
                label::after {
                    content: " (Line 1)*";
                    font-weight: 400;
                }
            }
            .address-line-two {
                label::after {
                    content: " (Line 2)";
                    font-weight: 400;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            // max-width: 300px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    emailGridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            label {
                font-size: ${TYPOGRAPHY.size.smaller};
            }
        `,
    },
    extGridItem: {
        width: [12, 6, 3, 2, 2],
        css: css`
            label {
                font-size: ${TYPOGRAPHY.size.smaller};
            }
        `,
    },
    phoneExtGridItem: {
        width: [12, 12, 6, 4, 4],
    },
    phoneExtRow: {
        css: css`
            display: flex;
            align-items: flex-start;
            gap: 8px;

            > *:first-child {
                flex: 1 1 auto;
                min-width: 0;
            }

            > *:last-child {
                flex: 0 0 70px;
                width: 70px;
            }

            label {
                font-size: ${TYPOGRAPHY.size.smaller};
            }
        `,
    },
    bufferGridItem: {
        width: [0, 0, 0, 4, 4],
    },
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    subscriptionGridItem: {
        width: 12,
        css: css`
            label {
                font-size: ${TYPOGRAPHY.size.smaller};
                color: ${COLORS.primary.light};
            }
        `,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: { width: 12 },
    submitGridItem: {
        width: [12, 9, 9, 9, 9],
        css: css`
            justify-content: flex-start;
            align-items: center;
            button {
                &:disabled:hover {
                    background: #939393;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            button {
                                width: 70%;
                            }
                        `,
                    ],
                    "max",
                )}
        `,
    },
    requiredLabelGridItem: {
        width: [12, 3, 3, 3, 3],
        css: css`
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            justify-content: flex-start;
                        `,
                    ],
                    "max",
                )}
            align-items: center;
            span {
                color: #ff3939;
            }
        `,
    },

    cancelButton: {
        typographyProps: {
            weight: TYPOGRAPHY.weight.bold,
            size: TYPOGRAPHY.size.smaller,
        },
        css: css`
            margin-left: 0.5rem;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            min-height: 40px;
            text-align: center;
            justify-content: center;
            > span {
                color: ${COLORS.secondaryBtn} !important;
            }
            & :hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
    },
    reasonGridItem: {
        width: 12,
    },
};

const styles = CreditAnalystFormStyles;
const StyledForm = getStyledWrapper("form");

const CreditAnalystForm = ({
    addAccount,
    validateReCaptcha,
    accountSettings,
    countries,
    shouldLoadCountries,
    loadCurrentCountries,
    defaultCountryAbbreviation,
    billToState,
    billToId,
    loadBillTo,
    sendCreditAnalystHandler,
}: Props) => {
    if (shouldLoadCountries) {
        loadCurrentCountries();
    }

    const selCountry = countries?.find(c => c.abbreviation.toUpperCase() === defaultCountryAbbreviation.toUpperCase());

    const [country, setCountry] = React.useState<CountryModel | undefined>();
    const [customerSelectedState, setCustomerSelectedState] = React.useState<StateModel | undefined>();

    React.useEffect(() => {
        setCountry(selCountry);
    }, [selCountry]);

    const userNameRequiredFieldMessage = siteMessage("CreateNewAccountInfo_UserName_Required");
    const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");

    const [email, setEmail] = useState("");
    const [userName, setUserName] = useState("");
    const [userNameError, setUserNameError] = useState(
        accountSettings.useEmailAsUserName ? "" : userNameRequiredFieldMessage,
    );
    const [errorMessage, setErrorMessage] = useState("");
    const [password, setPassword] = useState("");
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<ReactNode>("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState<ReactNode>("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const toasterContext = useContext(ToasterContext);
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [firstName, setFirstName] = React.useState("");

    const [lastName, setLastName] = React.useState("");
    const [title, setTitle] = React.useState("");

    const [phone, setPhone] = React.useState("");
    const [extension, setExtension] = React.useState("");
    const [fax, setFax] = React.useState("");
    const [compAddLine1, setCompAddLine1] = React.useState("");
    const [compAddLine2, setCompAddLine2] = React.useState("");
    const [city, setCity] = React.useState("");
    const [zipCode, setZipCode] = React.useState("");
    const [userMessage, setUserMessage] = React.useState("");
    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();

    React.useEffect(() => {
        if (!billToState.value && !billToState.isLoading && billToId) {
            loadBillTo({ billToId });
        }
    }, [billToState]);

    React.useEffect(() => {
        if (billToState.value) {
            const { firstName, lastName, address1, address2, phone, fax, email, city, state, postalCode } =
                billToState.value;

            setFirstName(firstName);
            setLastName(lastName);
            setCompAddLine1(address1);
            setCompAddLine2(address2);
            setEmail(email);
            setCity(city);
            const SelectedState: StateModel | undefined = country?.states?.find(s => s.id === state?.id);
            setCustomerSelectedState(SelectedState);
            // setCustomerSelectedState(state);
            const formattedFax = formatPhoneNumber(fax);
            const formattedPhone = formatPhoneNumber(phone);
            setFax(formattedFax);
            setPhone(formattedPhone);
            setZipCode(postalCode);

            // Validate each field as soon as bill-to data arrives, the same
            // way validateHandler runs on manual input change/blur.
            validateHandler({ name: "firstName", value: firstName ?? "" });
            validateHandler({ name: "lastName", value: lastName ?? "" });
            validateHandler({ name: "compAddLine1", value: address1 ?? "" });
            validateHandler({ name: "city", value: city ?? "" });
            validateHandler({ name: "state", value: SelectedState?.id ?? "" });
            validateHandler({ name: "email", value: email ?? "" });
            validateHandler({ name: "zipCode", value: postalCode ?? "" });
            validateHandler({ name: "phone", value: formattedPhone ?? "" });
            validateHandler({ name: "fax", value: formattedFax ?? "" });
        }
    }, [billToState]);

    // Handles the case where country/states data finishes loading *after*
    // billToState above already ran (common on client-side navigation).
    // Resolves the state exactly once, so it never overrides a value the
    // user has since picked or intentionally cleared.
    const hasAutoResolvedStateRef = React.useRef(false);
    React.useEffect(() => {
        if (hasAutoResolvedStateRef.current) {
            return;
        }
        if (billToState.value?.state && country?.states) {
            const SelectedState = country.states.find(s => s.id === billToState.value.state?.id);
            if (SelectedState) {
                setCustomerSelectedState(SelectedState);
                validateHandler({ name: "state", value: SelectedState.id });
                hasAutoResolvedStateRef.current = true;
            }
        }
    }, [country, billToState]);

    const firstNameChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setFirstName(input.value);
    };

    const lastNameChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setLastName(input.value);
    };

    const titleChangeHandler = (input: HTMLInputElement) => {
        validateHandler(input);
        setTitle(input.value);
    };

    const emailChangeHandler = (input: HTMLInputElement) => {
        const errorMessage = !email ? emailRequiredFieldMessage : validateEmail(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        setEmail(input.value);
        setUserName(input.value);
        validateHandler(input);
    };

    const phoneChangeHandler = (input: HTMLInputElement) => {
        setPhone(formatPhoneNumber(input.value));
        validateHandler(input);
    };

    const faxChangeHandler = (input: HTMLInputElement) => {
        setFax(formatPhoneNumber(input.value));
        validateHandler(input);
    };

    const extensionChangeHandler = (input: HTMLInputElement) => {
        setExtension(input.value);
        validateHandler(input);
    };

    const compAddLine1ChangeHandler = (input: HTMLInputElement) => {
        setCompAddLine1(input.value);
        validateHandler(input);
    };

    const compAddLine2ChangeHandler = (input: HTMLInputElement) => {
        setCompAddLine2(input.value);
    };

    const cityChangeHandler = (input: HTMLInputElement) => {
        setCity(input.value);
        validateHandler(input);
    };

    const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const SelectedState: StateModel | undefined = country?.states?.find(s => s.id === event.currentTarget.value);
        setCustomerSelectedState(SelectedState);
        validateHandler(event.currentTarget);
    };

    const zipCodeHandler = (input: HTMLInputElement) => {
        setZipCode(input.value);
        validateHandler(input);
    };

    const userMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setUserMessage(event.target.value);
        validateHandler(event.currentTarget);
    };

    const validateSubmitEnabled = () => {
        return !(emailError || passwordErrorMessage || confirmPasswordErrorMessage || userNameError);
    };

    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    React.useEffect(() => {
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    }, [formErrors]);

    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | InputObjectType,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = existingCustomerValidatorConfig[input.name as keyof ValidatorConfigType];
        if (!validatorConfig) {
            return;
        }
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            setFormErrors(prevState => removeKey(prevState, input.name));
        } else {
            setFormErrors(prevState => {
                return {
                    ...prevState,
                    [input.name]: isValidate ? isValidate.errorMsg : isValidate,
                };
            });
        }
        if (!validatorConfig.required && input.value === "") {
            setFormErrors(prevState => removeKey(prevState, input.name));
        }
    };

    React.useEffect(() => {
        const cloneFormErrors = { ...formErrors };
        for (const [key, value] of Object.entries(cloneFormErrors)) {
            const element: HTMLSelectElement | HTMLInputElement | null = document.querySelector(`[name="${key}"]`);
            if (element && element.value) {
                delete cloneFormErrors[key as keyof FormErrorsStateType];
                setFormErrors(removeKey(cloneFormErrors, key));
            }
        }
    }, []);

    const removeKey = (formErrorObject: FormErrorsStateType, deleteKey: string) => {
        return Object.assign(
            {},
            ...Object.entries(formErrorObject)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    const onBlurValidationHandler = (input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement) => {
        validateHandler(input);
    };

    const onSuccessHandler = () => {
        setErrorMessage("");
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        const isReCaptchaValid = await validateReCaptcha({
            location: "CreateAccount",
            recaptchaRef,
        });
        if (!isReCaptchaValid) {
            return;
        }
        setIsSubmitting(true);

        sendCreditAnalystHandler({
            firstName,
            lastName,
            title,
            addressLine1: compAddLine1,
            addressLine2: compAddLine2,
            city,
            state: customerSelectedState?.name,
            zipCode,
            email,
            faxNumber: fax,
            creditQuestion: userMessage,
            accountNumber: billToState.value?.customerNumber,
            phoneNumber: phone,
            phoneExtension: extension,
        });
    };

    console.log("test");

    const isSubmitEnabled = validateSubmitEnabled();

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.title}>{translate("Contact Credit Analyst")}</StyledWrapper>
            <StyledWrapper {...styles.headingInstruction}>
                <Typography as="p">
                    {translate("Please enter the requested information in the below form and click Submit.")}
                </Typography>
            </StyledWrapper>

            <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
                <StyledWrapper {...styles.userInfoTitle}>{translate("User Information")}</StyledWrapper>
                <GridContainer {...styles.mainGridContainer}>
                    <GridItem {...styles.userGridItem}>
                        <GridContainer {...styles.userGridContainer}>
                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("First Name")}
                                    value={firstName}
                                    data-test-selector="createAccount_firstName"
                                    onChange={e => firstNameChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.firstName && formErrors.firstName}
                                    name="firstName"
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.firstName ? AlertTriangle : undefined,
                                    }}
                                    required
                                />
                            </GridItem>

                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Last Name")}
                                    value={lastName}
                                    data-test-selector="createAccount_lastName"
                                    onChange={e => lastNameChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.lastName && formErrors.lastName}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.lastName ? AlertTriangle : undefined,
                                    }}
                                    name="lastName"
                                    required
                                />
                            </GridItem>

                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Title")}
                                    value={title}
                                    data-test-selector="createAccount_title"
                                    onChange={e => titleChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.title && formErrors.title}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.title ? AlertTriangle : undefined,
                                    }}
                                    name="title"
                                    required
                                />
                            </GridItem>

                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.emailTextField}
                                    type="email"
                                    label={translate("Email")}
                                    onChange={e => emailChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.email && formErrors.email}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.email ? AlertTriangle : undefined,
                                    }}
                                    value={email}
                                    data-test-selector="createAccount_email"
                                    maxLength={256}
                                    required
                                    name="email"
                                />
                            </GridItem>

                            <GridItem {...styles.emailGridItem} className="address-line-one">
                                <TextField
                                    {...styles.emailTextField}
                                    type="text"
                                    label={translate("Address")}
                                    // hint={translate("(Line 1)")}
                                    value={compAddLine1}
                                    data-test-selector="createAccount_company_address_line1"
                                    onChange={e => compAddLine1ChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.compAddLine1 && formErrors.compAddLine1}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.compAddLine1 ? AlertTriangle : undefined,
                                    }}
                                    name="compAddLine1"
                                />
                            </GridItem>
                            <GridItem {...styles.emailGridItem} className="address-line-two">
                                <TextField
                                    {...styles.emailTextField}
                                    type="text"
                                    label={translate("Address")}
                                    // hint={translate("(Line 1)")}
                                    value={compAddLine2}
                                    data-test-selector="createAccount_company_address_line2"
                                    onChange={e => compAddLine2ChangeHandler(e.currentTarget)}
                                />
                            </GridItem>

                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("City")}
                                    value={city}
                                    data-test-selector="createAccount_city"
                                    onChange={e => cityChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.city && formErrors.city}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.city ? AlertTriangle : undefined,
                                    }}
                                    name="city"
                                    required
                                />
                            </GridItem>
                            <GridItem {...styles.emailGridItem}>
                                <Select
                                    {...styles.selectStateStyle}
                                    label={translate("State")}
                                    value={
                                        customerSelectedState && customerSelectedState.id
                                        // (country && country.states && country.states[0] && country.states[0].id)
                                    }
                                    labelPosition="top"
                                    onChange={e => handleStateChange(e)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.state && formErrors.state}
                                    iconProps={{
                                        color: formErrors.state ? "danger" : "Success",
                                        src: formErrors.state ? AlertTriangle : ChevronDown,
                                    }}
                                    name="state"
                                    required
                                >
                                    <option value="">{translate("Select State")}</option>
                                    {country?.states?.map(customerSelectedState => (
                                        <option key={customerSelectedState.id} value={customerSelectedState.id}>
                                            {customerSelectedState.name}
                                        </option>
                                    ))}
                                </Select>
                            </GridItem>
                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.emailTextField}
                                    type="text"
                                    label={translate("Zip")}
                                    value={zipCode}
                                    onChange={e => zipCodeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.zipCode && formErrors.zipCode}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.zipCode ? AlertTriangle : undefined,
                                    }}
                                    name="zipCode"
                                    required
                                />
                            </GridItem>

                            <GridItem {...styles.phoneExtGridItem}>
                                <StyledWrapper {...styles.phoneExtRow}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        type="tel"
                                        label={translate("Phone")}
                                        value={phone}
                                        data-test-selector="createAccount_phone"
                                        onChange={e => phoneChangeHandler(e.currentTarget)}
                                        onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                        error={!!formErrors.phone && formErrors.phone}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.phone ? AlertTriangle : undefined,
                                        }}
                                        name="phone"
                                        required
                                    />
                                    <TextField
                                        {...styles.emailTextField}
                                        type="text"
                                        label={translate("Ext")}
                                        value={extension}
                                        data-test-selector="createAccount_extension"
                                        onChange={e => extensionChangeHandler(e.currentTarget)}
                                        onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                        error={!!formErrors.extension && formErrors.extension}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.extension ? AlertTriangle : undefined,
                                        }}
                                        name="extension"
                                    />
                                </StyledWrapper>
                            </GridItem>

                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.emailTextField}
                                    type="text"
                                    label={translate("Fax")}
                                    onChange={e => faxChangeHandler(e.currentTarget)}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    value={fax}
                                    error={!!formErrors.fax && formErrors.fax}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.fax ? AlertTriangle : undefined,
                                    }}
                                    data-test-selector="createAccount_fax"
                                    name="fax"
                                />
                            </GridItem>

                            <GridItem {...styles.reasonGridItem}>
                                <TextArea
                                    label={translate(
                                        "Please include detailed information about your credit releated questions",
                                    )}
                                    value={userMessage}
                                    onChange={userMessageChangeHandler}
                                    onBlur={e => onBlurValidationHandler(e.currentTarget)}
                                    error={!!formErrors.userMessage && formErrors.userMessage}
                                    name="userMessage"
                                    required
                                />
                            </GridItem>

                            {errorMessage && (
                                <GridItem {...styles.submitErrorGridItem}>
                                    <Typography {...styles.submitErrorTitle}>{errorMessage}</Typography>
                                </GridItem>
                            )}
                            <GridItem {...styles.reCaptchaGridItem}>
                                <ReCaptcha recaptchaRef={recaptchaRef} location="CreateAccount" />
                            </GridItem>
                            <GridItem {...styles.submitGridItem}>
                                <Button
                                    {...signInExistingAccountStyles.signInButton}
                                    type="submit"
                                    disabled={isButtonDisabled}
                                    data-test-selector="createAccount_createButton"
                                    data-content-category="Ecommerce"
                                    data-content-tracking="Create Account"
                                >
                                    {translate("SUBMIT")}
                                </Button>
                                {/* <Button {...blackBlueBtn.actionDeleteButton}>
                                <Link href="/">
                                    {translate("Cancel")}
                                </Link>
                                </Button> */}
                                <Link href="/" {...styles.cancelButton}>
                                    {translate("Cancel")}
                                </Link>
                            </GridItem>
                            <GridItem {...styles.requiredLabelGridItem}>
                                <StyledWrapper>
                                    <span>*</span>
                                    {translate(" Required")}
                                </StyledWrapper>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </StyledForm>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CreditAnalystForm),
    definition: {
        group: "Common",
        displayName: "Credit Analyst Form",
    },
};

export default widgetModule;
